const parseFormattedPrice = (value, language = 'en') => {
    const cleanedValue = value.replace(/[^\d.,-]/g, '');
    const decimalSeparator = language === 'fr' ? ',' : '.';
    const thousandSeparator = language === 'fr' ? ' ' : ',';
    const numericValue = cleanedValue.replace(new RegExp(`\\${thousandSeparator}`, 'g'), '');
    const finalValue = numericValue.replace(decimalSeparator, '.');
    return parseFloat(finalValue);
};
export default parseFormattedPrice;
